import { gql } from '@apollo/client';

export const GET_ROADS_HISTORY_BY_USER_ID = gql`
  query ListRoadsHistoryAdmin(
    $roadId: ObjectId!
    $userId: ObjectId!
    $input: SearchRoadsHistoryInput!
  ) {
    listUserRoadsHistory(roadId: $roadId, userId: $userId, input: $input) {
      docs {
        _id
        user {
          email
        }
        road {
          cover
          _id
          name
          episodes
        }
        completed
        currentEpisode
        createdAt
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const FIND_AUDIO_HISTORY = gql`
  query FindAudioHistoryPaginate($search: SearchAudioHistoryInput!) {
  findAudioHistoryPaginate(search: $search) {
    docs {
      episode
      audio
      _id
      total
    }
    limit
    page
    totalDocs
    totalPages
  }
}
`;

export const FIND_USERAUDIO_HISTORY = gql`
  query FindUsersAudioHistoryPaginate($search: SearchUsersAudioHistoryInput!) {
  findUsersAudioHistoryPaginate(search: $search) {
    docs {
      createdAt
      user {
        email
        fullName
      }
    }
    limit
    page
    totalDocs
    totalPages
  }
}
`;
